import { render } from "./EnrolleeSingleOnboardComponent.vue?vue&type=template&id=e22e04ca&scoped=true"
import script from "./EnrolleeSingleOnboardComponent.vue?vue&type=script&lang=js"
export * from "./EnrolleeSingleOnboardComponent.vue?vue&type=script&lang=js"

import "./EnrolleeSingleOnboardComponent.vue?vue&type=style&index=0&id=e22e04ca&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e22e04ca"]])

export default __exports__